import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { SiteProvider } from "@/context/SiteContext";
import { AuthProvider } from "@/context/AuthContext";
import SiteLayout from "@/components/site/SiteLayout";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import ContentPlans from "@/pages/ContentPlans";
import FreeResources from "@/pages/FreeResources";
import Gear from "@/pages/Gear";
import Community from "@/pages/Community";
import About from "@/pages/About";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import Questionnaire from "@/pages/Questionnaire";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";

import AdminLogin from "@/pages/admin/AdminLogin";
import ForgotPassword from "@/pages/admin/ForgotPassword";
import ResetPassword from "@/pages/admin/ResetPassword";
import AdminLayout from "@/pages/admin/AdminLayout";
import Dashboard from "@/pages/admin/Dashboard";
import Orders from "@/pages/admin/Orders";
import OrderDetail from "@/pages/admin/OrderDetail";
import Enquiries from "@/pages/admin/Enquiries";
import EmailCentre from "@/pages/admin/EmailCentre";
import Subscribers from "@/pages/admin/Subscribers";
import ProductsAdmin from "@/pages/admin/ProductsAdmin";
import GearAdmin from "@/pages/admin/GearAdmin";
import ResourcesAdmin from "@/pages/admin/ResourcesAdmin";
import VideosAdmin from "@/pages/admin/VideosAdmin";
import TestimonialsAdmin from "@/pages/admin/TestimonialsAdmin";
import SettingsAdmin from "@/pages/admin/SettingsAdmin";

function App() {
  return (
    <div className="App">
      <SiteProvider>
        <AuthProvider>
          <Toaster position="top-center" theme="dark" richColors />
          <BrowserRouter>
            <Routes>
              <Route element={<SiteLayout />}>
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/content-plans" element={<ContentPlans />} />
                <Route path="/free-resources" element={<FreeResources />} />
                <Route path="/gear" element={<Gear />} />
                <Route path="/community" element={<Community />} />
                <Route path="/about" element={<About />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/legal/:slug" element={<Legal />} />
                <Route path="/payment/success" element={<PaymentSuccess />} />
                <Route path="/payment/cancel" element={<PaymentCancel />} />
              </Route>
              <Route path="/questionnaire/:token" element={<Questionnaire />} />

              <Route path="/admin/login" element={<AdminLogin />} />
              <Route path="/admin/forgot-password" element={<ForgotPassword />} />
              <Route path="/admin/reset-password" element={<ResetPassword />} />
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Dashboard />} />
                <Route path="orders" element={<Orders />} />
                <Route path="orders/:id" element={<OrderDetail />} />
                <Route path="enquiries" element={<Enquiries />} />
                <Route path="emails" element={<EmailCentre />} />
                <Route path="subscribers" element={<Subscribers />} />
                <Route path="products" element={<ProductsAdmin />} />
                <Route path="gear" element={<GearAdmin />} />
                <Route path="resources" element={<ResourcesAdmin />} />
                <Route path="videos" element={<VideosAdmin />} />
                <Route path="testimonials" element={<TestimonialsAdmin />} />
                <Route path="settings" element={<SettingsAdmin />} />
              </Route>
            </Routes>
          </BrowserRouter>
        </AuthProvider>
      </SiteProvider>
    </div>
  );
}

export default App;
